import { z } from 'zod';

const tenantBaseFields = {
  name: z
    .string({ message: 'main.superAdmin.tenants.form.name.error' })
    .min(1, { message: 'main.superAdmin.tenants.form.name.error' }),
  description: z.string().nullish(),
  enabled: z
    .boolean({ message: 'main.superAdmin.tenants.form.enabled.error' }),
  allowTenantAdminRentAnalyticsExpenseVisibility: z.boolean(),
  logo: z
    .union([z.instanceof(File), z.string().min(1)])
    .optional()
    .nullable(),
  primaryColor: z.string().nullish(),
};

export const TenantCreateSchema = z.object(tenantBaseFields);

export const TenantUpdateSchema = z.object({
  ...tenantBaseFields,
  apiKey: z
    .string({ message: 'main.superAdmin.tenants.form.apiKey.error' })
    .min(1, { message: 'main.superAdmin.tenants.form.apiKey.error' })
    .max(50, { message: 'main.superAdmin.tenants.form.apiKey.maxLength' }),
});

export type TenantFormData = z.infer<typeof TenantUpdateSchema>;
export type TenantCreateFormData = z.infer<typeof TenantCreateSchema>;
